"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorFallbackCopyClipboard = void 0;
const react_1 = __importDefault(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const utils_1 = require("../../../utils");
const ErrorFallbackCopyClipboard = ({ error, title = 'Something went wrong.' }) => {
    const handleClick = () => {
        if (error) {
            navigator.clipboard.writeText(JSON.stringify(error));
            (0, utils_1.showNotification)('success', 'Copied');
        }
    };
    return (react_1.default.createElement(wl_ui_kit_1.WidgetFallback, { hideIcon: true },
        react_1.default.createElement(wl_ui_kit_1.Subtitle2, null, title),
        error ? react_1.default.createElement(wl_ui_kit_1.Subtitle2, { onClick: handleClick }, "Click to copy error details.") : null));
};
exports.ErrorFallbackCopyClipboard = ErrorFallbackCopyClipboard;
